// extracted by mini-css-extract-plugin
module.exports = {"button":"StarAction_button__1WsQW","icon":"StarAction_icon__1ICCF"};